module.exports = __webpack_public_path__ + "static/benifits-6ef7b008887d4aaf1525adc44b5bef60.jpg";